module.exports = __webpack_public_path__ + "static/media/yearentry.381025ca.jpg";